import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';
import { adminChangePassword, adminMe, clearAdminToken, getAdminToken } from '../lib/adminApi';
import { KeyRound, Loader2 } from 'lucide-react';

export default function AdminChangePassword() {
  const nav = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!getAdminToken()) nav('/admin/login');
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (form.newPassword.length < 8) { toast({ title: 'Password must be at least 8 characters' }); return; }
    if (form.newPassword !== form.confirm) { toast({ title: 'Passwords do not match' }); return; }
    setBusy(true);
    try {
      await adminChangePassword(form.currentPassword, form.newPassword);
      toast({ title: 'Password updated' });
      nav('/admin');
    } catch (err) {
      toast({ title: 'Update failed', description: err?.response?.data?.detail || 'Please try again.' });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white grid place-items-center p-6">
      <div className="w-full max-w-md rounded-2xl bg-white text-neutral-900 p-7 shadow-2xl">
        <div className="flex items-center gap-2 text-teal-800"><KeyRound size={16} /><span className="text-xs uppercase tracking-widest">First-time setup</span></div>
        <h1 className="font-display text-2xl mt-2">Set a new password</h1>
        <p className="text-sm text-neutral-500 mt-1">You are using a temporary password. Please set a permanent one now.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>Current password</Label><Input type="password" className="h-11 mt-1.5" value={form.currentPassword} onChange={(e) => setForm({ ...form, currentPassword: e.target.value })} /></div>
          <div><Label>New password</Label><Input type="password" className="h-11 mt-1.5" value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })} placeholder="Minimum 8 characters" /></div>
          <div><Label>Confirm new password</Label><Input type="password" className="h-11 mt-1.5" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-teal-800 hover:bg-teal-900 text-white">{busy ? (<><Loader2 size={16} className="mr-1.5 animate-spin" /> Updating…</>) : ('Update password')}</Button>
        </form>
      </div>
    </div>
  );
}
